export default __webpack_public_path__ + "static/media/woodenspoon.9fdba1ee.png";